import SignUpFormModal from './SignUpFormModal';

export default SignUpFormModal;


// WEBPACK FOOTER //
// ./src/components/SignUpFormModal/index.jsx